export function formatIpcaDpMonthYear(rows) {
  const formatted = {
    years: [],
    yearsWithMonths: {},
    data: {},
  };

  (rows ?? []).forEach((r) => {
    const y = r.year;
    const m = r.month;

    if (!formatted.yearsWithMonths[y]) {
      formatted.years.push(y);
      formatted.yearsWithMonths[y] = [];
    }

    if (!formatted.yearsWithMonths[y].includes(m)) {
      formatted.yearsWithMonths[y].push(m);
    }

    const key = `${m}/${y}`;

    let parsed;
    try {
      parsed = typeof r.json_ipcadp === 'string'
        ? JSON.parse(r.json_ipcadp)
        : r.json_ipcadp;
    } catch (e) {
      parsed = [];
    }

    formatted.data[key] = parsed;
  });

  // ordena anos e meses
  formatted.years.sort((a, b) => a - b);
  Object.keys(formatted.yearsWithMonths).forEach((y) => {
    formatted.yearsWithMonths[y].sort((a, b) => a - b);
  });

  return formatted;
}